import { render, staticRenderFns } from "./SettingsSection.vue?vue&type=template&id=1186444a&scoped=true"
import script from "./SettingsSection.vue?vue&type=script&lang=js"
export * from "./SettingsSection.vue?vue&type=script&lang=js"
import style0 from "./SettingsSection.vue?vue&type=style&index=0&id=1186444a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1186444a",
  null
  
)

export default component.exports